<div class="content-translations">
  <div class="title">
    <div class="toolbar-content-translations">
      <div class="left-section">
        <div class="hero-text">
          <h1>
            Language translation
          </h1>
          <p>For internal content, accuracy isn't guaranteed. For official content, please use
            <b><a href="https://thermofisher.sharepoint.com/sites/LanguageServices" target="_blank">translation services.</a></b>
          </p>
        </div>
      </div>
      <div class="middle-section"></div>
      <div class="right-section">
        <a href="https://thermofisher.sharepoint.com/sites/LanguageServices" target="_blank" class="button-link">
          <img src="assets/icons/flyout/flyout-14px-dark-gray-mono.svg" alt="flyout" class="flyout-icon">
          Translation Services
        </a>
      </div>
    </div>
  </div>
  <kmd-alerts kmd-error [(show)]="showErrorAlert" [alertText]="errorAlertText" [alertTitle]="errorAlertTitle" [dismissible]="true" [floating]="true"></kmd-alerts>
  <kmd-alerts kmd-success [(show)]="isCopied" [icon]="true" [alertText]="alertCopyText" [floating]="true" id="copy-success-alert"></kmd-alerts>
  <div class="document-translations-container">
    <app-document-translations-notification class="desktop-notification"
                                            *ngIf="(translationContentType==='Document') && featureFlags.documentTranslationNotification"
                                            [ngClass]="{'alert-active': showErrorAlert}"/>
    <div class="left-section">
      <div class="content-type" *ngIf="featureFlags.documentTab">
        <h2>Choose the type of content to translate</h2>
        <div class="translations-disclaimer">
          <p>
            Inaccuracies may occur in Gene.AI. This Language Translation capability is powered by the validated MT Hive tool and should be used for internal documents only. Please be mindful that each translation incurs a cost to the company, use your judgement before proceeding.
          </p>
        </div>
        <div class="translations-content-btns" [ngClass]="{'disabled': disableTab()}">
          <core-segmentedbuttons>
            <core-segmentedbuttons-item label='Text' slot='segment' (click)="setTranslationContentType('Text')"
                                        [selected]="translationContentType === 'Text'" />
            <core-segmentedbuttons-item label='Document' slot='segment' (click)="setTranslationContentType('Document')"
                                        [selected]="translationContentType === 'Document'" />

          </core-segmentedbuttons>
        </div>
       </div>
      <div class="translate-docs" *ngIf="(translationContentType==='Document')">
        <div class="container-docs">
          <div class="left-section">
            <app-document-translations-mobile-notification />
            <div class="controls">
              <div class="dropdown-container">
                <app-file-translations-language-dropdown
                  (onSourceLanguageSelected)="sourceLanguageSelected($event)"
                  (onTargetLanguageSelected)="targetLanguageSelected($event)"
                  (onSourceLanguageFailureDetected)="onSourceLanguageFailureAlert($event)"/>
              </div>
            </div>
            <div class="language-error-notifications-container">
              <!-- Insufficient Text Notifications -->
              <ng-container *ngFor="let notification of insufficientTextNotifications">
                <app-insufficient-text-notification
                  class = "insufficient-text-notification"/>
              </ng-container>
              <!-- Unsupported Language Notifications -->
              <ng-container *ngFor="let notification of unsupportedLanguageNotifications">
                <app-unsupported-language-notification
                  class = "unsupported-language-notification"
                  [detectedLanguage]="notification.detectedLanguage"/>
              </ng-container>
              <!-- Language Mismatch Notifications -->
              <ng-container *ngFor="let notification of languageMismatchNotifications">
                <app-language-mismatch-notification
                  class = "language-mismatch-notification"
                  [detectedLanguage]="notification.detectedLanguage"/>
              </ng-container>
              <!-- Password Protected Notifications -->
              <ng-container *ngFor="let notification of passwordProtectedNotifications">
                <app-password-protected-notification
                  class = "password-protected-notification"/>
              </ng-container>
            </div>
            <div class="file-manager-container">
              <div class="top-section">
                <div id="file-manager-modal-upload" >
                  <div class="select-documents-title">
                    Select documents
                  </div>
                  <p class="select-documents-description">
                    Select the source and target language for translation and upload your documents. Processing the files may take some time, depending on the file size and content. Once uploaded, you can switch to another application and return later to download the translated files. Completed translations will be available under the "Translated Documents" section.
                    <br><br>
                    <span class="note-text">Note: Scanned documents cannot be translated.</span>
                  </p>
                    <app-file-translations-uploader class="file-manager-upload"
                      [destroy$]="documentTabDestroy$"
                      [sourceLanguage] ="selectedSourceLanguage" [targetLanguage]="selectedTargetLanguage"
                      (onUploading)="onUploading($event)" (onFileUploadErrorAlert)="onFileUploadErrorAlert($event)"
                      (onTranslating)="onTranslating($event)"
                      (onLanguageDetected)="onLanguageDetected($event)"
                      (onFileTranslatedRefreshTranslatedList) = "refreshTranslatedList($event)"
                      (onErrorLanguageFileRemoved)="removeErrorNotification($event)"
                      (onSwitchToTextTab)="setTranslationContentType('Text')"
                      (onInsufficientTextDetected)="onInsufficientTextNotification($event)"
                      (onPasswordProtectedDetected)="onPasswordProtectedNotification($event)"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="translate-text" *ngIf="(translationContentType==='Text')">
        <div class="container-texts">
          <div class="input-text">
            <div class="label">
              <span>Enter text to translate</span>
              <p>*</p>
            </div>
            <textarea id="inputText" [(ngModel)]="inputText" maxlength="{{maxInputCharLimit()}}"></textarea>
            <div class="bottom-container">
              <countdown-label id="translationsCountdownLabel" [maxlength]="maxInputCharLimit()" [value]="inputText" />
              <span id="clearText" (click)="clearText()" [ngClass]="isClearTextEnabled() ? 'clear-enabled' : 'clear-disabled'">
                <img src="assets/icons/close/size=16px,%20style=mono.svg" id="clearTextIcon"><span>Clear</span>
              </span>
            </div>
          </div>
          <div class="output-text">
            <div class="controls">
              <ng-container *ngIf="featureFlags.canadianFrenchTranslation; else previousLanguageDropdown"> 
                <kmd-dropdown [options]="languageListNew" optionLabelKey="name" [inlineLabel]="dropdownLabel" (onChange)="onLanguageChange($event.selectedOption)">
                </kmd-dropdown>
              </ng-container>
              <ng-template #previousLanguageDropdown>
                <kmd-dropdown [options]="languageList" optionLabelKey="name" [inlineLabel]="dropdownLabel" (onChange)="onLanguageChange($event.selectedOption)">
                </kmd-dropdown>
              </ng-template>
              <button id="translate" kmdFeaturedButton (click)="translateText()" [disabled]="!isTranslateTextEnabled()">
                Translate
              </button>
            </div>
            <div>
              <textarea id="response" [(ngModel)]="response" readonly></textarea>
            </div>
            <div class="copy-response-container">
              <span class="copy-button" (click)="copyResponse()">
                <div [ngClass]="isCopyEnabled() ? 'copy-enabled' : 'copy-disabled'">
                  <img src="assets/icons/copy/Size=24px,%20Style=Mono.svg" class="gene-icon" id="copy-response-icon"><span>Copy</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <kmd-modal class="loading-modal" [id]="'loadingResponseModal'" modalSize="small" [closeOnClickingOutside]="false">
      <div>Generating response</div>
      <kmd-loading-wheel></kmd-loading-wheel>
    </kmd-modal>
  </div>

  <app-translated-documents-list [refreshTableEvent]="refreshEventEmitter" [translationContentType]="translationContentType" />

  <kmd-modal *ngIf="featureFlags.documentTab" [id]="confirmationModalId"
             id="confirm-leave-translations-modal" modalSize="mini" [headline]="getConfirmationModalHeadline()">
    <div id="text-confirm"  *ngIf="isUploading">
      <p>If you stop now, any uploaded files will be lost. </p>
    </div>
    <div>
      <p><b>Would you like to continue?</b></p>
    </div>
    <div class="modal-buttons-container">
      <button id="stay-btn" (click)="handleConfirmLeave()" kmdInfoButton>Yes</button>
      <button id='switch-btn' (click)="handleCancelLeave()" kmdFeaturedButton>No</button>
    </div>
  </kmd-modal>
</div>

